












import { computed, defineComponent } from '@nuxtjs/composition-api';

import ValidationErrorMessage from '~/components/ValidationErrorMessage.vue';

export default defineComponent({
  name: 'InputLicencePlate',
  components: { ValidationErrorMessage },
  props: {
    value: {
      type: String,
      default: '',
    },
    validationError: {
      type: String,
      default: null,
    },
  },
  setup(props, { emit }) {
    const hasError = computed(() => !!props.validationError);

    const onInput = (event: any) => {
      emit('input', event.target?.value);
    };

    return {
      hasError,
      onInput,
    };
  },
});
